var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "basicSettings"
    }
  }, [_c("a-tabs", {
    attrs: {
      activeKey: _vm.tabKey,
      animated: false
    },
    on: {
      change: _vm.tabChange
    }
  }, [_c("a-tab-pane", {
    key: "1",
    attrs: {
      tab: _vm.$t("deploy.deploySetting")
    }
  }, [_c("DeploySetting")], 1), _c("a-tab-pane", {
    key: "2",
    attrs: {
      tab: _vm.$t("deploy.apiErrorList")
    }
  }, [_c("ApiErrorList")], 1), _c("a-tab-pane", {
    key: "4",
    attrs: {
      tab: _vm.$t("basicSettings.other")
    }
  }, [_c("DeployOther")], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };